import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	header: {
		id: 'polaris-lib-view-empty-state.views.list-view.header',
		defaultMessage: 'Add ideas to your list',
		description: 'Header of the new list view hint',
	},
	description: {
		id: 'polaris-lib-view-empty-state.views.list-view.description',
		defaultMessage: 'Create ideas and use custom fields to prioritize them.',
		description: 'New list hint to start',
	},
	roadmapViewHeader: {
		id: 'polaris-lib-view-empty-state.views.list-view.roadmap-view-header',
		defaultMessage: 'The projects you’ve selected don’t contain ideas',
		description: 'Header of the empty roadmap list view',
	},
	roadmapViewDescription: {
		id: 'polaris-lib-view-empty-state.views.list-view.roadmap-view-description',
		defaultMessage: 'Add ideas to the projects and they will show up here.',
		description: 'Empty roadmap list view hint',
	},
});
